module.exports = __webpack_public_path__ + "img/ic-add-farm.18ffde3b.svg";